import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";
import dayjs from "dayjs";

const rowStyle = { margin: 0, padding: "5px 0" };

export const lawyerActionDropdownMenu = [
    { key: "consultationView", label: "Consultation View" },
    { key: "history", label: "History" }
];

export const customerActionDropdownMenu = [
    { key: "history", label: "View" },
    // { key: "refund", label: "Refund" }
];

export const actionDropdownMenu = lawyerActionDropdownMenu;

export const TRANSACTION_TAB_DATA = [
    { label: "Advocate", content: "LAWYERS", key: "1" },
    { label: "Customer", content: "CUSTOMER", key: "2" }
];

export const TRANSACTION_STATUS_OPTIONS = [
    { key: "PAID", value: "PAID" },
    { key: "UNPAID", value: "UNPAID" }
];

export const TRANSACTION_CATEGORIES = [
    { key: "CUSTOMER_RECHARGE", value: "Customer Recharge" },
    { key: "PAY_CONSULTATION", value: "Pay Cons." },
    { key: "CONSULTATION_PAYOUT_TO_LAWYER", value: "Cons. Payout to Advocate" },
    { key: "PAY_PENALTY", value: "Pay Penalty" },
    { key: "REFUND_TO_CUSTOMER", value: "Refund to Customer" },
    { key: "CONSULTATION_FEE_FROM_MY_BALANCE", value: "Cons. Fee from My Balance" }
];

export const TRANSACTION_HISTORY_STATUS_OPTIONS = [
    { key: "SUCCESS", value: "Success" },
    { key: "FAILED", value: "Failed" },
];

export const LAWYER_TRANSACTION_COLUMNS = (actionRender, status, handlePayment) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Advocate ID",
        width: 100,
        dataIndex: "lawyerNo",
        key: "lawyerNo",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    ...(status === "UNPAID" ? [
        {
            title: "Advocate Name",
            dataIndex: "lawyerName",
            key: "lawyerName",
            render: (text) => <p style={{ fontWeight: "bold", ...rowStyle }}>{text}</p>
        },
        {
            title: "Mobile Number",
            dataIndex: "mobileNumber",
            key: "mobileNumber",
            render: (text) => <p style={rowStyle}>{formatPhoneNumber(text) || "Nil"}</p>
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
        },
        {
            title: "UnPaid Cons.",
            render: (detail) => <p style={{ textAlign: "center", ...rowStyle }}>{detail?.consultationIds?.length || 0}</p>,
            key: "numberOfCons",
            align: "center"
        },
        {
            title: "Balance Amount",
            dataIndex: "balanceAmount",
            key: "balanceAmount",
            render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
        },
        {
            title: "TDS Amount",
            dataIndex: "tdsAmount",
            key: "tdsAmount",
            render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
        },
        {
            title: "Payment",
            width: 120,
            render: (_, record) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                        style={{
                            backgroundColor: "#A68B5C",
                            color: "white",
                            border: "none",
                            padding: "5px 15px",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                        onClick={() => handlePayment && handlePayment(record)}
                    >
                        Pay now
                    </button>
                </div>
            )
        },
        {
            title: "Action",
            width: 80,
            render: (list) => actionRender(list)
        }
    ] : [
        {
            title: "Advocate Name",
            render: (detail) => (
                <div>
                    <p style={{ fontWeight: "bold", ...rowStyle }}>{detail?.lawyerName || "Nil"}</p>
                </div>
            )
        },
        {
            title: "Mobile Number",
            dataIndex: "mobileNumber",
            key: "mobileNumber",
            render: (text) => <p style={rowStyle}>{formatPhoneNumber(text) || "Nil"}</p>
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text) => <p style={rowStyle}>{text || "Nil"}</p>,
        },
        {
            title: "Number Of Cons.",
            render: (detail) => <p style={{ textAlign: "center", ...rowStyle }}>{detail?.consultationIds?.length || 0}</p>,
            key: "numberOfCons",
            align: "center"
        },
        {
            title: "Total Payment",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
        },
        {
            title: "Action",
            width: 80,
            render: (list) => actionRender(list)
        }
    ])
];

export const CUSTOMER_TRANSACTION_COLUMNS = (actionRender) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Customer ID",
        width: 120,
        dataIndex: "customerNo",
        key: "customerNo",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Customer Name",
        render: (detail) => (
            <div>
                <p style={{ fontWeight: "bold", ...rowStyle }}>{detail?.customerName || "Nil"}</p>
            </div>
        )
    },
    {
        title: "Mobile Number",
        dataIndex: "mobileNumber",
        key: "mobileNumber",
        render: (text) => <p style={rowStyle}>{formatPhoneNumber(text) || "Nil"}</p>
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Cons. Paid Amount",
        dataIndex: "totalConsPaidAmt",
        key: "totalConsPaidAmt",
        render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
    },
    {
        title: "Total Recharge Amount",
        dataIndex: "totalRechargeAmt",
        key: "totalRechargeAmt",
        render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
    },
    {
        title: "Action",
        width: 80,
        render: (list) => actionRender(list)
    }
];

export const HISTORY_COLUMNS = (isLawyer) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Date",
        dataIndex: "transactionDate",
        width: 120,
        key: "date",
        render: (text) => {
            const parsedDate = dayjs(text);
            return <p style={rowStyle}>{text && parsedDate?.isValid() ? parsedDate.format("DD-MM-YYYY") : "Nil"}</p>;
        }
    },
    {
        title: "Transaction ID",
        width: 300,
        dataIndex: "transactionId",
        key: "transactionId",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Category",
        width: 200,
        dataIndex: "paymentCategory",
        key: "category",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Total Amount",
        dataIndex: "amount",
        width: 120,
        key: "amount",
        render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
    },
    {
        title: "TDS Amount",
        dataIndex: "tdsAmount",
        width: 120,
        key: "tdsAmount",
        render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
    },
    {
        title: "Paid Amount",
        dataIndex: "finalAmount",
        width: 120,
        key: "finalAmount",
        render: (text) => <p style={rowStyle}>{`₹ ${formatAmount(text)}`}</p>
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text) => {
            let color = "#E53935";
            if (text === "SUCCESS") color = "#4CAF50";
            else if (text === "PENDING") color = "#F1C40F";
            return (
                <p style={{ color, fontWeight: "bold", ...rowStyle }}>
                    {text}
                </p>
            );
        }
    }
];
